import { motion } from "framer-motion";

const stats = [
  { value: "2015", label: "Année de création" },
  { value: "150 000", label: "Escargots élevés / an" },
  { value: "100 %", label: "Réalisé sur place" },
  { value: "En famille", label: "Mère, fils & fille" },
];

const Exploitation = () => {
  return (
    <section data-testid="exploitation-section" id="exploitation" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_50px_rgba(44,42,40,0.18)]">
              <img
                src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/8tta7yqg_20000PX.jpg"
                alt="Gros gris de notre élevage à Savianges"
                className="w-full h-[460px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 lg:-right-10 w-52 h-52 rounded-2xl overflow-hidden border-4 border-sable shadow-xl hidden sm:block">
              <img
                src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/4x0sszpi_maman%20agathe.jpg"
                alt="Béatrice et sa fille au stand Escarg'Holala"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Notre passion familiale</span>
            <h2 className="font-heading text-4xl sm:text-5xl text-foreground mt-2 tracking-tight">
              Une exploitation née de l'amour du terroir
            </h2>
            <div className="space-y-5 mt-7 text-foreground/80 text-lg leading-relaxed">
              <p>
                Fondée en <strong className="text-bordeaux">2015</strong> par
                <strong className="text-bordeaux"> Béatrice Genieys</strong>, Escarg'Holala est une maison
                d'héliciculture où mère, fils et fille œuvrent de concert, au rythme des saisons
                et dans le plus grand respect du vivant.
              </p>
              <p>
                Chaque année, près de <strong className="text-bordeaux">150 000 escargots</strong> grandissent
                dans nos parcs. De l'élevage à la cuisson, en passant par la transformation et la vente,
                <strong> chaque étape est menée sur place</strong>, animée d'une même quête d'excellence.
              </p>
              <p>
                Un savoir-faire artisanal transmis avec patience et passion, au service d'un produit
                d'exception, profondément ancré dans la gastronomie bourguignonne.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 mt-10">
              {stats.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label}`} className="border-l-2 border-bordeaux/40 pl-4">
                  <div className="font-heading text-3xl text-bordeaux font-600">{s.value}</div>
                  <div className="text-sm text-foreground/60 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Exploitation;
